// @flow
import { createSelector } from 'reselect'
import { pathOr } from 'ramda'

export const selectCoverageCarValue = createSelector(
  (state) => pathOr(undefined, ['userData', 'data', 'cic', 'carValue'], state),
  (carValue) => carValue,
)
